import { useEffect } from 'react';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { base44 } from '@/api/base44Client';

const SOURCES = {
  '/services/hair-color': 'hair-color-chalandri',
  '/services/haircuts': 'womens-haircut-chalandri',
  '/services/babylights': 'babylights-chalandri',
  '/milbon-360-chalandri': 'milbon-360-chalandri',
};
const validItems = (items) => (Array.isArray(items) ? items : []).filter(i => typeof i?.question === 'string' && i.question.trim() && typeof i.answer === 'string' && i.answer.trim());

export default function useServiceFAQs({ path, sourceSlug, fallback = [], items }) {
  const client = useQueryClient();
  const slug = sourceSlug || SOURCES[path];
  const query = useQuery({
    queryKey: ['service-faq', path, slug], enabled: items === undefined,
    queryFn: async () => {
      if (slug) {
        const response = await base44.functions.invoke('getPublicLandingPage', { slug });
        if (Array.isArray(response.data?.page?.faq_items)) return validItems(response.data.page.faq_items);
      }
      const records = await base44.entities.Content.filter({ page: 'service-faq', key: path }, '-updated_date', 1);
      return records[0]?.text ? validItems(JSON.parse(records[0].text)) : null;
    },
    staleTime: 60000,
  });
  useEffect(() => {
    if (items !== undefined) return;
    const refresh = () => client.invalidateQueries({ queryKey: ['service-faq'] });
    const stopContent = base44.entities.Content.subscribe(refresh);
    const stopPages = base44.entities.LandingPage.subscribe(refresh);
    return () => { stopContent(); stopPages(); };
  }, [client, items]);
  return { items: validItems(items !== undefined ? items : query.data ?? fallback), loading: query.isPending && items === undefined && !fallback.length, error: query.isError };
}